import { createContext, useContext } from 'react';
import type { TourMenu, TourStep } from './steps';

export interface TourApi {
  step: TourStep | null;
  index: number;
  total: number;
  /** Nav dropdown the current step needs held open, if any. */
  openMenu: TourMenu | null;
  /** True once the user has completed or dismissed the tour. */
  done: boolean;
  start: () => void;
  next: () => void;
  back: () => void;
  /** Leave the tour. `completed` distinguishes finishing from skipping (both stop the reminder). */
  stop: (completed: boolean) => void;
  /** Advance past a step whose anchor never rendered. */
  skip: () => void;
  /** Dismiss the dashboard reminder without taking the tour. */
  dismiss: () => void;
}

/** Inert default so components can call useTour() even if rendered outside the provider. */
const NOOP: TourApi = {
  step: null, index: -1, total: 0, openMenu: null, done: true,
  start: () => {}, next: () => {}, back: () => {}, stop: () => {}, skip: () => {}, dismiss: () => {},
};

export const TourContext = createContext<TourApi>(NOOP);

export function useTour(): TourApi {
  return useContext(TourContext);
}
